import { capitalize } from "../../../components/helpers/capitalize";

export const convertOutletList = (outlets) => {
  let convertedOutlets = [];

  if (!outlets || !outlets.length) return [];

  outlets.forEach((outlet) => {
    convertedOutlets.push({
      value: outlet.id,
      label: capitalize(outlet.name),
    });
  });
  return convertedOutlets;
};
